import React from "react";
import { LOCALES } from "../i18n/locales";
import { Link } from "react-router-dom";
import './Header.css';
function Header(props){
    const languages = [
        { name: "Deutsch", code: LOCALES.GERMAN },
        { name: "English", code: LOCALES.ENGLISH },
        // { name: "日本語", code: LOCALES.JAPANESE },
        { name: "Français", code: LOCALES.FRENCH },

    ];
  return (
    <header>
        <Link to="/">
            <img src="../logo.png" alt="Logo - BLH" />
        </Link>
        {/*<img src="http://localhost:3000/logo.png" alt="Logo - BLH" />*/}
        <div className="switcher">
            {/* Language switch dropdown here */}
            Languages{" "}
            <select onChange={props.handleChange} value={props.currentLocale}>
                {languages.map(({ name, code }) => (
                    <option key={code} value={code}>
                        {name}
                    </option>
                ))}
            </select>
        </div>
    </header>
  );
}

export default Header;

